import './style.scss';
import { FormikProps } from 'formik/dist/types';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Toast, ToastProps } from 'views/mutual/toast';

export type SendSMSParam = {
  authenticationCode: string;
};
type SendSMSFormikType = FormikProps<SendSMSParam>;

type SendSMSTemplate = {
  formik: SendSMSFormikType;
  text: string;
  phoneNumber?: string;
  onSendSMS: () => void;
  toastProps: ToastProps;
  isUpdate: boolean;
};

export const SendSMSTemplate = ({ formik, text, phoneNumber, onSendSMS, toastProps, isUpdate }: SendSMSTemplate) => {
  return (
    <>
      <form onSubmit={formik.handleSubmit} className="loginsStyle">
        <div className="loginsStyle_inputs">
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.medium}
            label={phoneNumber ? `末尾が”${phoneNumber}”の電話番号に送信された認証コードを入力してください` : text}
          />
          <div className="loginsStyle_inputs_wrapper">
            <div className="loginsStyle_inputs_wrapper_label">認証コード</div>
            <div className="loginsStyle_inputs_wrapper_button">
              <input
                type="text"
                name="authenticationCode"
                value={formik.values.authenticationCode}
                onChange={formik.handleChange}
                placeholder="半角数字で入力"
              />
            </div>
            {formik.errors.authenticationCode ? (
              <div className="errorRed">{formik.errors.authenticationCode}</div>
            ) : null}
          </div>
          <div className="loginsStyle_inputs_buttons">
            <Button
              label="認証"
              buttonFill={ButtonFill.primary}
              buttonSize={ButtonSize.medium}
              type={ButtonType.Submit}
            />
            <Button
              type={ButtonType.Button}
              label="認証コードを再送信"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.medium}
              onClick={onSendSMS}
            />
          </div>
        </div>

        <Toast {...toastProps} />
      </form>
    </>
  );
};
